<template>
  <div>
    <b-modal
      id="pointCloudProcessTrackingModal"
      size="xl"
      content-class="sub-menu-bg-blue-transparent"
      body-class="scroll-Container"
      title="Point Cloud Process Tracking"
      hide-footer
     
      scrollable
      @hide="clearForm()"
      @shown="getAutopopulatedData()"
    >
      <b-container>
        <!-- DPR-associated fields -->
        <div
          v-if="
            incomingData != null &&
            (dprCameraStatus != null ||
              dprComments != null ||
              dprDMIStatus != null)
          "
        >
          <h3 class="px-3 py-2 text-center">Associated DPR Entry</h3>
          <b-row>
            <b-col>
              <b-form-group class="px-3 py-2">
                <label>Camera Status</label>
                <b-form-input v-model="dprCameraStatus" disabled />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group class="px-3 py-2">
                <label>DMI Status</label>
                <b-form-input v-model="dprDMIStatus" disabled />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group class="px-3 py-2">
                <label>DPR Comments</label>
                <b-form-textarea
                  v-model="dprComments"
                  rows="4"
                  class="text-input"
                  disabled
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <hr style="border-top: 1px solid rgba(255, 255, 255, 0.5)" />
        </div>

        <!-- Alert for if no corresponding DPR entry is found -->
        <b-row v-else-if="!inputtingPCPT" class="p-3">
          <b-col class="text-center">
            <span class="alert alert-danger">
              <b style="text-shadow: none"> No corresponding DPR entry found. </b>
            </span>
          </b-col>
        </b-row>

        <!-- Drive and Assigned To fields -->
        <b-row>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Drive</label>
              <b-form-input v-model="driveLabel" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Assigned To</label>
              <b-form-select v-model="assignedTo" :options="assignedToOptions">
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- System, JDAY, and Date fields -->
        <b-row>
          <b-col cols="4">
            <b-form-group class="px-3 py-2">
              <label>System</label>
              <b-form-input v-model="systemSelected" disabled />
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <b-form-group class="px-3 py-2">
              <label>JDAY</label>
              <b-form-input v-model="jDay" type="number" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Date</label>
              <b-form-input v-model="date" type="date" disabled />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- State and Collection Type fields -->
        <b-row>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>State</label>
              <multiselect
                v-model="state"
                :options="stateOptions"
                :multiple="true"
                :close-on-select="false"
                placeholder=""
                disabled
              >
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Collection Type</label>
              <multiselect
                v-model="collectionType"
                :options="collectionTypesSelection"
                :multiple="true"
                :close-on-select="false"
                placeholder=""
                disabled
              >
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Status and Checkboxes field -->
        <b-row>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Status</label>
              <b-form-select
                v-model="status"
                :options="statusOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="px-3 py-2">
              <b-form-checkbox v-model="checkedOldData">
                Checked Against Old Data
              </b-form-checkbox>
              <b-form-checkbox v-model="receivedFromField" disabled>
                Received from field
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Date Started & Completed fields -->
        <b-row>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Date Started</label>
              <b-form-input v-model="dateStarted" type="date" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Date Completed</label>
              <b-form-input v-model="dateCompleted" type="date" />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- CM & Ramp Acquisition Summary fields -->
        <b-row>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>CM Acquisition Summary (miles)</label>
              <b-form-input v-model="cmAcqSumRounded" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Ramp Acquisition Summary (miles)</label>
              <b-form-input v-model="rampAcqSumRounded" disabled />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Aerial Recollect Miles and Primary Road fields -->
        <b-row>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Aerial Recollect (miles)</label>
              <b-form-input v-model="aerialRecollectMilesRounded" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Primary Roads (miles)</label>
              <b-form-input v-model="primaryRoadsRounded" disabled />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Secondary Roads and Tertiary Roads fields -->
        <b-row>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Secondary Roads (miles)</label>
              <b-form-input v-model="secondaryRoadsRounded" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Tertiary Roads (miles)</label>
              <b-form-input v-model="tertiaryRoadsRounded" disabled />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Days in backlog and Date Received fields -->
        <b-row>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Days in backlog</label>
              <b-form-input v-model="daysInBacklog" type="number" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <b-form-group class="px-3 pt-2">
                  <label>Date Received</label>
                  <b-form-input v-model="dateReceived" type="date" />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <!-- Total miles and Trail Miles fields -->
        <b-row>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Total Miles</label>
              <b-form-input v-model="totalMilesRounded" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Trail Miles</label>
              <b-form-input v-model="trailMilesRounded" disabled />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Comments field -->
        <b-row>
          <b-col>
            <b-form-group class="px-3 py-2">
              <label>Comments</label>
              <b-form-textarea v-model="comments" rows="4"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Submit and Clear buttons -->
        <b-row class="p-3">
          <b-col class="text-center">
            <b-button
              variant="primary"
              size="lg"
              type="submit"
              @click="submitForm(assignedToOriginal == assignedTo)"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal
      id="PCPTReassignmentModal"
      size="md"
      content-class="menu-bg-blue-transparent-modal"
      body-class="scroll-Container"
      title="Track Reassignment"
      hide-footer
     
    >
      <b-container class="text-center">
        <!-- Warning Text -->
        <b-row class="row-input py-2">
          <b-col class="row-label-left-justify">
            <h5>Warning:</h5> You are attempting to assign this track when it has already been assigned to
            {{ assignedToOptions.find(x => x.value === this.assignedToOriginal).text }}.
            Are you sure you wish to reassign this track?
          </b-col>
        </b-row>

        <!-- Submit button -->
        <b-row class="row-input py-2">
          <b-col>
            <b-button
              variant="primary"
              size="lg"
              type="submit"
              @click="reassignmentConfirmation()"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'
export default {
  name: 'MMP_HDT_PointCloud',
  components: {
    Multiselect
  },
  props: ['incomingData', 'inputtingPCPT'],
  data() {
    return {
      aerialRecollectMiles: null,
      aerialRecollectMilesRounded: null,
      assignedTo: 0,
      assignedToOptions: [
        {
          value: 0,
          text: 'None'
        }
      ],
      assignedToOriginal: 0,
      backup: null,
      checkedOldData: null,
      cmAcqSum: null,
      cmAcqSumRounded: null,
      collectionType: [],
      collectionTypesSelection: [
        'CM',
        'Ramps',
        'Primary',
        'Secondary',
        'Tertiary',
        'Residential',
        'Aerial Recollect'
      ],
      comments: null,
      date: null,
      dateCompleted: null,
      dateReceived: null,
      dateStarted: null,
      daysInBacklog: null,
      dprCameraStatus: null,
      dprDMIStatus: null,
      dprComments: null,
      driveLabel: null,
      jDay: null,
      pstRoads: null,
      primaryRoads: null,
      primaryRoadsRounded: null,
      rampAcqSum: null,
      rampAcqSumRounded: null,
      receivedFromField: null,
      secondaryRoads: null,
      secondaryRoadsRounded: null,
      state: null,
      stateOptions: [],
      status: null,
      statusId: null,
      statusOptions: [],
      systemSelected: null,
      tertiaryRoads: null,
      tertiaryRoadsRounded: null,
      totalMiles: null,
      totalMilesRounded: null,
      trackId: null,
      trailMiles: null,
      trailMilesRounded: null
    }
  },
  methods: {
    clearForm() {
      this.aerialRecollectMiles = null
      this.aerialRecollectMilesRounded = null
      this.assignedTo = 0
      this.assignedToOriginal = 0
      this.backup = null
      this.checkedOldData = null
      this.cmAcqSum = null
      this.cmAcqSumRounded = null
      this.collectionType = []
      this.comments = null
      this.date = null
      this.dateCompleted = null
      this.dateReceived = null
      this.dateStarted = null
      this.daysInBacklog = null
      this.dprCameraStatus = null
      this.dprComments = null
      this.dprDMIStatus = null
      this.driveLabel = null
      this.jDay = null
      this.primaryRoads = null
      this.primaryRoadsRounded = null
      this.rampAcqSum = null
      this.rampAcqSumRounded = null
      this.receivedFromField = null
      this.secondaryRoads = null
      this.secondaryRoadsRounded = null
      this.state = null
      this.stateOptions = []
      this.status = null
      this.statusId = null
      this.systemSelected = null
      this.tertiaryRoads = null
      this.tertiaryRoadsRounded = null
      this.totalMiles = null
      this.totalMilesRounded = null
      this.trackId = null
      this.trailMiles = null
      this.trailMilesRounded = null
      this.$emit('cleared')
    },
    getHDTOperators() {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION + '/api/drive_tracking/getHdtOperators',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getHdtOperators API Call Error: ' + content.errors)
            } else {
              let hdtOperators = content.rows
              for (let i = 0; i < hdtOperators.length; i++) {
                this.assignedToOptions.push({
                  value: i + 1,
                  text: hdtOperators[i].name
                })
              }
              // Alphabetically sorts names
              this.assignedToOptions.sort((a, b) => { return a.text.localeCompare(b.text) })
              // Get index of 'None' object
              let assignedToNoneIndex = this.assignedToOptions.findIndex(
                x => (x.value == 0)
              )
              // Temporarily save 'None' object
              let assignedToNoneObj = this.assignedToOptions[assignedToNoneIndex]
              // Removes 'None' object from middle of array
              this.assignedToOptions.splice(assignedToNoneIndex, 1)
              // Adds 'None object back in the front of the array
              this.assignedToOptions.unshift(assignedToNoneObj)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    submitForm(assignedToUnchanged) {
      if (assignedToUnchanged || this.assignedToOriginal == 0) {
        if (sessionStorage.token) {
          axios
            .get(process.env.API_LOCATION + '/api/drive_tracking/update_drive', {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                identifiers: {
                  aerialRecollectMiles: this.aerialRecollectMiles,
                  cmAcqSum: this.cmAcqSum,
                  collectionType: this.collectionType,
                  date: this.date,
                  daysInBacklog: this.daysInBacklog,
                  jDay: this.jDay,
                  primaryRoads: this.primaryRoads,
                  rampAcqSum: this.rampAcqSum,
                  secondaryRoads: this.secondaryRoads,
                  state: this.state,
                  statusId: this.statusId,
                  system: this.systemSelected,
                  tertiaryRoads: this.tertiaryRoads,
                  totalMiles: this.totalMiles,
                  trackId: this.trackId,
                  trailMiles: this.trailMiles
                },
                valuesToUpdate: {
                  assignedTo: this.assignedToOptions.find(x => x.value === this.assignedTo).text,
                  checkedOldData: this.checkedOldData,
                  comments: this.comments,
                  dateCompleted: this.dateCompleted,
                  dateReceived: this.dateReceived,
                  dateStarted: this.dateStarted,
                  receivedFromField: this.receivedFromField,
                  status: this.statusOptions[this.status].db_value
                }
              }
            })
            .then(response => {
              const content = response.data
              if (content.errors) {
                console.log(
                  'Point Cloud Process Tracking Entry API Call Error: ' +
                    content.errors
                )
              } else {
                this.$bvModal.hide('pointCloudProcessTrackingModal')
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          console.log('No User Token')
        }
      } else {
        this.$bvModal.show('PCPTReassignmentModal')
      }
    },
    formatDateForDisplay(date) {
      if (date === null) {
        return
      }
      const newDate = new Date(date)
      return (
        newDate.getFullYear() +
        '-' +
        (newDate.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        newDate.getDate().toString().padStart(2, '0')
      )
    },
    getJdayInDateFormat(jday) {
      let retVal = ''
      let finished = false
      let year = 2000 + Number(jday.toString().substring(0, 2))
      let dayOfYear = Number(jday.toString().substring(2))
      let leapYear = (year % 4 == 0 && year % 100 != 0) || year % 400 == 0
      let monthDays = [
        31,
        leapYear ? 29 : 28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
      ]
      monthDays.forEach((days, index) => {
        if (dayOfYear - days > 0) {
          dayOfYear -= days
        } else if (!finished) {
          finished = true
          retVal = this.formatDateForDisplay(
            year + '-' + (index + 1) + '-' + dayOfYear
          )
        }
      })
      return retVal
    },
    getAutopopulatedData() {
      let data = this.incomingData
      if (data != null) {
        let incomingAssignedObj = this.assignedToOptions.find(
          x => x.text === data.assigned_user
        )
        this.assignedTo = incomingAssignedObj ? incomingAssignedObj.value : 0
        this.assignedToOriginal = this.assignedTo
        if (data.aerial_miles != null) {
          this.aerialRecollectMiles = data.aerial_miles
          this.aerialRecollectMilesRounded = parseFloat(this.aerialRecollectMiles.toFixed(2))
          this.totalMiles += this.aerialRecollectMiles
          if (data.aerial_miles != 0) {
            this.collectionType.push('Aerial Recollect')
          }
        }
        if (data.backup != null) {
          this.backup = data.backup
        }
        this.checkedOldData = data.checked_old_data
        if (data.cm_miles != null) {
          this.cmAcqSum = data.cm_miles
          this.cmAcqSumRounded = parseFloat(this.cmAcqSum.toFixed(2))
          this.totalMiles += this.cmAcqSum
          if (data.cm_miles != 0) {
            this.collectionType.push('CM')
          }
        }
        this.comments = data.comments
        if (data.complete_date != null) {
          this.dateCompleted = this.formatDateForDisplay(data.complete_date)
        }
        if (data.field_sn != null) {
          this.driveLabel = data.field_sn
        }
        if (data.julian_day != null) {
          this.jDay = data.julian_day
          this.date = this.getJdayInDateFormat(this.jDay)
        }
        if (data.primary_miles != null) {
          this.primaryRoads = data.primary_miles
          this.primaryRoadsRounded = parseFloat(this.primaryRoads.toFixed(2))
          this.totalMiles += this.primaryRoads
          if (data.primary_miles != 0) {
            this.collectionType.push('Primary')
          }
        }
        if (data.ramp_miles != null) {
          this.rampAcqSum = data.ramp_miles
          this.rampAcqSumRounded = parseFloat(this.rampAcqSum.toFixed(2))
          this.totalMiles += this.rampAcqSum
          if (data.ramp_miles != 0) {
            this.collectionType.push('Ramps')
          }
        }
        if (data.received_date != null) {
          this.dateReceived = this.formatDateForDisplay(data.received_date)
          this.receivedFromField = true
          let finishedDate = this.dateCompleted
            ? new Date(this.dateCompleted)
            : new Date()
          this.daysInBacklog = Math.round(
            (finishedDate - new Date(this.dateReceived)) / 86400000
          )
        }
        if (data.secondary_miles != null) {
          this.secondaryRoads = data.secondary_miles
          this.secondaryRoadsRounded = parseFloat(this.secondaryRoads.toFixed(2))
          this.totalMiles += this.secondaryRoads
          if (data.secondary_miles != 0) {
            this.collectionType.push('Secondary')
          }
        }
        if (data.start_date != null) {
          this.dateStarted = this.formatDateForDisplay(data.start_date)
        }
        if (data.status != null) {
          // Axios call to get valid status transitions from RFDB
          if (sessionStorage.token) {
            axios
              .get(process.env.API_LOCATION + '/api/drive_tracking/getStatusTransitions', {
                headers: {
                  'x-auth-token': sessionStorage.token
                }
              })
              .then(response => {
                const content = response.data
                if (content.errors) {
                  console.log(`Status Transitions API Call Error: ${content.errors}`)
                } else {
                  // Store retrieved status transitions here
                  let transitions = content.rows
                  let newStatusOptions = []

                  // Loop through retrieved transitions to update statusOptions array
                  for (let i in transitions) {
                    let transition = transitions[i]
                    let found = -1

                    /* Check if status object has already been added. 
                    If it has, modify the existing object. */
                    for (let j in newStatusOptions) {
                      if (newStatusOptions[j].db_value == transition.start_status) {
                        found = j
                        break
                      }
                    }

                    /* If status object has been found,
                    push transition. Else, create new object. */
                    if (found > -1) {
                      // Add transition and reset found to default value
                      newStatusOptions[found].transitions.push(transition.end_status)
                      found = -1
                    } else {
                      /* Push new object using the current transition's
                      end_status as the transition array's inital value. */
                      newStatusOptions.push({
                        value: newStatusOptions.length,
                        text: transition.start_status.replace(/_/g, ' '),
                        db_value: transition.start_status,
                        transitions: [transition.end_status],
                        disabled: false
                      })
                    }
                  }
                  this.statusOptions = newStatusOptions
                  this.status = this.statusOptions.filter(s => s.db_value == data.status)[0].value

                  // Gets valid transitions and includes itself through array concatenation
                  let validTransitions = this.statusOptions[this.status].transitions.concat(
                    [this.statusOptions[this.status].db_value]
                  )

                  /** WEBGIS-3212 - Commented this code to enable all the options of status Dropdown */
                  // this.statusOptions.forEach((status, index) => {
                  //   let validTransition = !validTransitions.includes(status.db_value)
                  //   this.statusOptions[index]['disabled'] = validTransition
                  // })
                }
              })
              .catch(function (error) {
                console.log(error)
              })
          } else {
            console.log('No User Token')
          }
        }
        if (data.status_id != null) {
          this.statusId = data.status_id
        }
        if (data.subcountry != null) {
          data.subcountry.forEach(state => {
            this.stateOptions.push(state)
          })
          this.state = this.stateOptions
        }
        this.systemSelected = data.system
        if (data.tertiary_miles != null) {
          this.tertiaryRoads = data.tertiary_miles
          this.tertiaryRoadsRounded = parseFloat(this.tertiaryRoads.toFixed(2))
          this.totalMiles += this.tertiaryRoads
          if (data.tertiary_miles != 0) {
            this.collectionType.push('Tertiary')
          }
        }
        this.trackId = data.track_id
        this.trailMiles = data.trail_miles
        this.trailMilesRounded = parseFloat(this.trailMiles.toFixed(2))
        this.totalMilesRounded = parseFloat(this.totalMiles.toFixed(2))

        // Axios call to get DPR-matching entry's data
        if (sessionStorage.token) {
          axios
            .get(process.env.API_LOCATION + '/api/dpr/getHDTMatch', {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                recordJday: data.julian_day,
                recordSystem: data.system
              }
            })
            .then(response => {
              const content = response.data
              if (content.errors) {
                console.log(
                  'Matching DPR Entry API Call Error: ' + content.errors
                )
              } else {
                // Store retrieved data here
                let data = content.rows[0]
                if (data != null) {
                  if (data.issues != null) {
                    let formattedData = data.issues.map(issue => JSON.parse(issue))
                    let cameraIssues = []
                    formattedData.forEach(issue => {
                      switch (issue.id) {
                        case '1':
                          this.dprDMIStatus = issue.issue
                          break
                        case '2':
                        case '3':
                          cameraIssues.push(issue.issue)
                          break
                      }
                    })
                    this.dprCameraStatus = cameraIssues.length > 0 ? cameraIssues.join(' and ') : null
                  } else {
                    this.dprCameraStatus = data.camera
                    this.dprDMIStatus = data.dmi_status
                  }
                  this.dprComments = data.comments
                }
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          console.log('No User Token')
        }
      }
    },
    reassignmentConfirmation() {
      this.$bvModal.hide('PCPTReassignmentModal')
      this.submitForm(true)
    }
  },
  mounted() {
    this.getHDTOperators()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>